import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { usePopperActions } from './FIlterCount.hooks'
import { RootState } from 'cityads-v3/types/reducer'
import classes from './FilterCount.scss'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import Snackbar from '@mui/material/Snackbar'
import Typography from '@mui/material/Typography'
import WidgetHider from 'cityads-v3/components/WidgetHider/WidgetHider'

export type FilterCountProps = {
  onApply?: () => void
  filterEl: React.MutableRefObject<HTMLElement>
}

export default function FilterCount({
  filterEl,
  onApply,
}: FilterCountProps): JSX.Element {
  const { t } = useTranslation(['main'])
  const isLoading = useSelector((state: RootState) => state.offers.filterTotal.isLoading)
  const total = useSelector((state: RootState) => state.offers.filterTotal.total)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)

  const {
    handleApply,
    open,
  } = usePopperActions({
    onApply,
    isLoading,
    filterEl
  })

  if (isMobile) {
    return (
      <>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={open && !!filterEl.current}
          message={(
            <>
              {t('filterResults')}: {isLoading ? <CircularProgress size={16} /> : total}
            </>
          )}
          action={
            <>
              <Button color="primary" size="small" onClick={handleApply}>
                {t('buttons.apply')}
              </Button>
            </>
          }
        />

        {open && !!filterEl.current ? <WidgetHider variant="mobile" /> : null}
      </>
    )
  }

  return (
    <Popper
      className={classes.popper}
      open={open && !!filterEl.current}
      anchorEl={filterEl.current}
      placement="right"
      transition
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} timeout={350} style={{ transformOrigin: '0 50%' }}>
          <Paper elevation={8}>
            <Box p={1} display="grid" gap="4px">
              <div className={classes.results}>
                <Typography variant="body2">
                  {t('filterResults')}:
                </Typography>
                {isLoading ? <CircularProgress size={16} /> : <Typography variant="body2">{total}</Typography>}
              </div>
              {onApply ? (
                <Button
                  color="primary"
                  size="small"
                  variant="contained"
                  onClick={handleApply}
                >
                  {t('buttons.apply')}
                </Button>
              ) : null}
            </Box>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}
